import { render, staticRenderFns } from "./push_record.vue?vue&type=template&id=571a91e4&"
import script from "./push_record.vue?vue&type=script&lang=js&"
export * from "./push_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports